
import { defineComponent, toRaw } from "vue"

export default defineComponent({
  data: () => ({
    nominations: toRaw([
      {
        title: "Изобретатель года",
        text: "Участники номинации&nbsp;&mdash; ученые, инженеры, изобретатели старше 35&nbsp;лет.",
      },
      {
        title: "Молодой изобретатель года",
        text: "Участники номинации&nbsp;— студенты среднего профессионального и&nbsp;высшего образования, аспиранты, молодые ученые, изобретатели в&nbsp;возрасте 18&nbsp;— 35&nbsp;лет.",
      },
      {
        title: "Юный изобретатель года",
        text: "Участники номинации&nbsp;— школьники в&nbsp;возрасте от&nbsp;6&nbsp;до&nbsp;18&nbsp;лет.",
      },
      {
        title: "Рационализатор года",
        text: "Участники номинации&nbsp;— рационализаторы любого возраста.",
      },
      {
        title: "Гран-при",
        text: "Присуждается участнику конкурса без возрастных ограничений за&nbsp;создание и&nbsp;внедрение изобретений и&nbsp;полезных моделей, обладающих высоким техническим уровнем и&nbsp;имеющих максимальный экономический и/или социальный эффект.",
      },
    ] as const),
  }),
})
